// 用户相关API
import request from '@/utils/request'

/**
 * 获取oss配置接口
 * @returns {Promise}
 */
export function queryAutograph() {
  return request({
    url: '/6454d9663e508',
    method: 'get'
  })
}

/**
 * 获取用户信息
 * @returns {Promise}
 */
export function getUserInfo() {
  return request({
    url: '/5c78c4772da97',
    method: 'get'
  })
}


